import { useContext, useState } from 'react';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import PurchaseOrdersSelection from './PurchaseOrdersSelection';
import PurchaseOrdersClaim from './PurchaseOrdersClaim';

const PurchaseOrdersClaimSelection = () => {
  const { currentStep } = useContext(ClaimContext);
  const [purchaseOrder, setPurchaseOrder] = useState(null);

  switch (currentStep) {
    case 1:
      return <PurchaseOrdersSelection setPurchaseOrder={setPurchaseOrder} />;
    case 2:
      return <PurchaseOrdersClaim purchaseOrder={purchaseOrder} />;

    default:
      return <></>;
  }
};

export default PurchaseOrdersClaimSelection;
